import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';

import * as _ from 'lodash';

import { Message } from '../../../../../models/message';
import { Chat } from '../../../../../models/chat';
import { UserContact } from '../../../../../models/user-contact';
import { PinnedMessageService } from '../pinned-message.service';
import { AccountManagerService } from '../../../../services/account/account-manager.service';
import { UserContactService } from '../../../../services/data/user-contact/user-contact.service';
import { TnDialogService } from '../../../../../utilities/tn-dialog/tn-dialog.service';
import { TnNotificationService } from '../../../../../utilities/tn-notification/tn-notification.service';
import { LoggerService } from '../../../../../utilities/logger/logger.service';

interface PinnedMessageRow {
  message: Message;
  pinnedByContact: UserContact;
}

@Component({
  selector: 'tn-pinned-messages',
  templateUrl: './pinned-messages.component.html',
  styleUrls: ['./pinned-messages.component.scss']
})
export class PinnedMessagesComponent implements OnInit, OnDestroy {
  chat: Chat;
  canPin: boolean = false;
  rows: PinnedMessageRow[] = [];

  private _pinnedMessagesSub: Subscription;

  constructor(
    public dialogRef: MatDialogRef<PinnedMessagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _pinnedMessageService: PinnedMessageService,
    private _accountManagerService: AccountManagerService,
    private _userContactService: UserContactService,
    private _tnDialogService: TnDialogService,
    private _tnNotificationService: TnNotificationService,
    private _loggerService: LoggerService
  ) { }

  ngOnInit() {
    this.dialogRef.updateSize('50vw');

    this.chat = this.data.chat;
    this.canPin = this._pinnedMessageService.checkIfCanPin(this.chat, this._accountManagerService.userId);

    this._pinnedMessagesSub = this._pinnedMessageService.pinnedMessages$.subscribe(() => {
      this.updateRows();
    });

    // always resync from the server when the dialog opens, never trust a possibly stale cache
    this._pinnedMessageService.refreshPinnedMessages(this.chat.chat_id);
    this.updateRows();
  }

  ngOnDestroy() {
    if (this._pinnedMessagesSub) {
      this._pinnedMessagesSub.unsubscribe();
    }
  }

  updateRows(): void {
    let msgs = this._pinnedMessageService.getPinnedMessagesForChat(this.chat.chat_id);
    this.rows = _.map(msgs, (m) => {
      return {
        message: m,
        pinnedByContact: m.pinned_by ? this._userContactService.getUserContactByUserId(m.pinned_by) : null
      };
    });
  }

  onMessageClick(m: Message): void {
    this._loggerService.log('Jump to pinned message: ' + m.message_id);
    if (this.data.onMessageJump) {
      this.data.onMessageJump(m);
    }
    this._tnDialogService.closeAllDialogs();
  }

  onUnpin(m: Message, event: MouseEvent): void {
    event.stopPropagation();
    this._loggerService.log('Clicked unpin on pinned message: ' + m.message_id);
    this._tnNotificationService.showConfirmByTranslateKey(
      'WEBCLIENT.CHATROOM.PINNED_MESSAGE.UNPIN_CONFIRM_MSG',
      () => {
        this._pinnedMessageService.unpinMessage(this.chat.chat_id, m.message_id);
      }
    );
  }
}
